import React, { useState } from 'react';

const Chevron = ({ open }) => <svg className={`lp-disc-chev ${open ? 'open' : ''}`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9" /></svg>;

const PiscesDisclosureModule = () => {
    const [modOpen, setModOpen] = useState(true);
    const [cdOpen, setCdOpen] = useState(true);
    const [openCD, setOpenCD] = useState(null);

    return (
        <section className="lp-disc-sec" style={{ marginBottom: 0 }}>
            <div className="lp-prob-head">
                <div className="lp-eyebrow" data-lp-reveal><span className="lp-ww-eyebrow">The Disclosure Module</span></div>
                <h2 className="lp-h2" data-lp-reveal data-lp-delay="60" style={{ fontSize: '35px', maxWidth: '1200px' }}>73 questions. All 17 Core Disclosures. Nothing missed.</h2>
                <p className="lp-prob-lead" data-lp-reveal data-lp-delay="120">Structured against PS 2.3.2R and the LSE PSM Appendix 2 framework — the same standards your operator uses for admission assessment. Not a general-purpose questionnaire.</p>
            </div>
        </section>
    );
};

export default PiscesDisclosureModule;
